import React from 'react';
import { Link } from 'react-router-dom';
import { BarChart3, ArrowLeftRight } from 'lucide-react';

const ADMIN_TOOLS = [
  {
    id: 'dashboards',
    title: 'Processing Intelligence',
    description: 'Extraction accuracy, CSR effort, A+ gaps, and session logs',
    icon: BarChart3,
    to: '/admin/dashboards',
    gradient: 'from-amber-400 to-orange-500',
  },
  {
    id: 'uom',
    title: 'UOM Normalizer',
    description: 'Manage unit of measure equivalences used during validation',
    icon: ArrowLeftRight,
    to: '/admin/uom',
    gradient: 'from-sky-400 to-blue-500',
  },
];

export default function AdminLanding() {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-white">Admin Tools</h2>
        <p className="text-slate-400 mt-1">Manage and monitor Order processing operations</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {ADMIN_TOOLS.map(tool => {
          const Icon = tool.icon;
          return (
            <Link
              key={tool.id}
              to={tool.to}
              className="group bg-slate-800 border border-slate-700 rounded-xl p-6 hover:border-slate-600 hover:bg-slate-800/80 transition-all"
            >
              <div className={`w-12 h-12 bg-gradient-to-br ${tool.gradient} rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                <Icon className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-lg font-semibold text-white group-hover:text-amber-400 transition-colors">
                {tool.title}
              </h3>
              <p className="text-sm text-slate-400 mt-1">
                {tool.description}
              </p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
